export const SET_DOMAINS_EMAIL = 'SET_DOMAINS_EMAIL';
export const GET_DOMAINS_EMAIL_REQUEST = 'GET_DOMAINS_EMAIL_REQUEST';
export const SET_CURENT_EMAIL = 'SET_CURENT_EMAIL';
export const UPDATE_UNREACHABLE_EMAIL_REQUEST = 'UPDATE_UNREACHABLE_EMAIL_REQUEST';
export const UPDATE_UNREACHABLE_EMAIL = 'UPDATE_UNREACHABLE_EMAIL';
